export default "https://cdn-static.gokick.com/assets/b4d66d8cd7eb0aaa0b454a3d41ce872cff261527/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";